import React from 'react';

import { IoMdCheckmark } from 'react-icons/io';

export default ({ checkmarkColumnsData, threePerRow }) => {
  return (
    <>
      {checkmarkColumnsData.map(el =>
        !threePerRow ? (
          <div className="col-md-6">
            <div className="single-item">
              <div className="icon">
                <div className="section-points">
                  <div className="item">
                    <div className="ok-icon ">
                      <IoMdCheckmark />
                    </div>
                  </div>
                </div>
              </div>
              <div className="content">
                <h3 className="tt">{el.title}</h3>
                <div className="dd">
                  <p>{el.subtitle}</p>
                </div>
              </div>
            </div>
          </div>
        ) : (
            <div className="col-md-4">
              <div className="item">
                <span className="ok-icon">
                  <IoMdCheckmark />
                </span>
                <div className="content">
                  <div className="my-2 font-weight-bold">{el.title}</div>
                  <p>{el.subtitle}</p>
                </div>
              </div>
            </div>
          )
      )}
    </>
  );
};
